import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/',
        loader: async () => {
          const { HomePage } = await import('./HomePage');
          return <HomePage />;
        },
      },
    }),
  ],
});

export default homePlugin;
